import {Component, OnInit, Inject, ViewChild, ElementRef, Input, ChangeDetectorRef, OnDestroy} from '@angular/core';
import { HasSubscriptions } from '../../has-subscriptions';
import { debounceTime, filter } from 'rxjs/operators';
import {FormBuilder, FormGroup} from '@angular/forms';
import { DOCUMENT } from '@angular/platform-browser';
import { SearchResult } from '../../search-bar/search-bar.component';
import {ListingsService} from '../../../services/listings.service';
import { SearchResult as ElasticSearchResult } from '../../../classes/object-response';
import {Router} from '@angular/router';
import { HomeEstimatorListing } from '../../../classes/interfaces';

@Component({
  selector: 'app-home-estimator-search-bar',
  templateUrl: './home-estimator-search-bar.component.html',
  styleUrls: ['./home-estimator-search-bar.component.scss']
})
export class HomeEstimatorSearchBarComponent extends HasSubscriptions implements OnInit, OnDestroy {
  isSearching: boolean = false;
  showAdditionalActionsButtons: boolean = false;
  searchForm: FormGroup;
  @ViewChild('searchBarRef') searchBarRef: ElementRef;
  locationResults: SearchResult[] = [];
  showSearchResults: boolean = false;
  @Input() placeholder: string = '';
  @Input() focus: boolean = false;
  offMarketSubscription: any;

  constructor(
    @Inject(DOCUMENT) private document,
    private _formBuilder: FormBuilder,
    private _listingService: ListingsService,
    private cdRef: ChangeDetectorRef,
    private _router: Router
  ) {
    super();
    this.searchForm = this._formBuilder.group({searchInput: ''});
  }

  get searchInput(): string {
    return this.searchForm.controls.searchInput.value;
  }

  set searchInput(value: string) {
    this.searchForm.controls.searchInput.setValue(value);
  }

  ngOnInit() {
    this.addSub(this.searchForm.get('searchInput').valueChanges
      .pipe(debounceTime(200))
      .pipe(filter((searchInput: string) => {
        if (!searchInput) {
          this._resetResults();
          return false;
        }
        return true;
      }))
      .subscribe((s) => this._getQueryPredictionsSearch(s)));
  }

  onSearchInputClick() {
    this._getQueryPredictions();
    this.showSearchResults = true;
  }

  private _getQueryPredictions() {
    if (!!this.searchInput) {
      this._getQueryPredictionsSearch(this.searchInput);
    }
    else this._resetResults();
  }

  private _getQueryPredictionsSearch(searchInput: string) {
    if ( this.offMarketSubscription ) {
      this.offMarketSubscription.unsubscribe();
    }
    this.isSearching = true;
    this.offMarketSubscription = this._listingService.searchOffMarketListings(searchInput)
      .subscribe( (s) =>
        this._handleQueryPredictions(searchInput, s)
    );
  }

  private _handleQueryPredictions(searchInput: string, listings: ElasticSearchResult<HomeEstimatorListing[]>) {
    if (listings !== null && listings.results !== null && listings.results.length >= 0) {
      const list = listings.results.map((e) => new SearchResult(e.addressLine, e.detailUrl, 'location'));
      this.locationResults = list;
    }
    this.isSearching = false;
    this.cdRef.detectChanges();
  }

  private _resetResults() {
    this.locationResults = [];
  }

  onLoseFocus() {
    setTimeout(() => {
      if (!this.searchBarRef.nativeElement.contains(this.document.activeElement)) this.showSearchResults = false;
    })
  }

  onSelectResult($event) {
    this._router.navigate([$event.data]);
    this.showSearchResults = false;
    this.focus = false;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.offMarketSubscription) {
      this.offMarketSubscription.unsubscribe();
    }
  }
}
